import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# 🧪 Scripting Documentation

## 📝 Script Functions

The following functions are available for use in HawkClient scripts.

---

## ⚡ Pre-Request Script

- \`hc.request.getBody()\`
- \`hc.request.getUrl()\`
- \`hc.request.setUrl("urlValue")\`
- \`hc.request.getHeaders()\`
- \`hc.request.getBodyType()\`
- \`hc.request.setHeader("key", "value")\`
- \`hc.request.setJsonBody({ })\`
- \`hc.request.setMethod("value")\`
- \`hc.request.getMethod()\`
- \`hc.setRequestVariable("key", "value")\`
- \`hc.getEnvVariable("key")\`
- \`hc.getGlobalVariable("key")\`
- \`hc.getVariable("key")\`
- \`hc.getCollectionVariable("key")\`
- \`hc.setCollectionVariable("key", "value")\`
- \`hc.setGlobalVariable("key", "value")\`
- \`hc.setEnvVariable("key", "value")\`
- \`hc.getRequestVariable("key")\`

---

## 📩 Post-Response Script

- \`hc.response.getBody()\`
- \`hc.response.getStatus()\`
- \`hc.response.getStatusText()\`
- \`hc.response.getHeaders()\`
- \`hc.response.getTimeTaken()\`
- \`hc.test("description", () => { })\`
- \`hc.getEnvVariable("key")\`
- \`hc.getGlobalVariable("key")\`
- \`hc.getVariable("key")\`
- \`hc.getCollectionVariable("key")\`
- \`hc.setCollectionVariable("key", "value")\`
- \`hc.setGlobalVariable("key", "value")\`
- \`hc.setEnvVariable("key", "value")\`

---

## 🛠️ Example: Writing Tests

\`\`\`js
hc.test("should match expected value", () => {
  const body = hc.response.getBody();
  expect(body.value[0].name).to.equal("ram");
});
\`\`\`
`;

const ScriptDoc = () => {
  return (
    <MarkDownRenderer
      title="Scripting Documentation"
      markDownText={markdownContent}
    />
  );
};

export default ScriptDoc;
